import classnames from 'classnames'
import React from 'react'
import { selectShouldDisplayMapTools } from '../../../store/ui/ui.selectors'
import { isGE } from '../../Device'
import logoMappy from '../../genericComponents/logo-mappy-bordered.svg'
import { withEverySelectorTruthy } from '../../utils/react-redux'
import s from './Logo.less'

const Logo = () => (
  <div className={classnames(s.Logo, isGE() ? s.centeredBottomLogo : 'maplibregl-ctrl-bottom-left')}>
    <img src={logoMappy} width="60" height="16" />
  </div>
)

export default withEverySelectorTruthy(selectShouldDisplayMapTools)(Logo)
